import { FunctionComponent, useCallback, useMemo, ChangeEvent } from "react"
import { observer } from "mobx-react-lite"
import { Switch, SwitchOnChangeData } from "@fluentui/react-switch"
import { useGenericListSettings, getParamId, PARAM_DELETED } from "@knowmax/genericlist-core"
import { LANGUAGE_LABELRECYCLEBIN } from "../../types/language"

export const RecycleBinFilter: FunctionComponent<{ listId?: string }> = observer(({ listId }) => {
  const settings = useGenericListSettings()

  const paramid = useMemo(() => getParamId(PARAM_DELETED, listId), [listId])

  const checked = useMemo(() => {
    const value = settings.params.get(paramid)

    // Parameter is checked if it exists and is not explicitly set to 'false'
    // Its mere existence (even with no value) means it's true
    return settings.params.has(paramid) && value !== 'false'
  }, [paramid, settings.params])
  
  const select = useCallback((ev: ChangeEvent<HTMLInputElement>, data: SwitchOnChangeData) => {
    const params = new URLSearchParams(settings.params)
    params.delete(paramid)

    if (data.checked) {
      // Set parameter without value - its existence means it's true
      params.set(paramid, '')
    }
    settings.serialize(params)
  }, [settings.params, paramid])

  return (
    <Switch
      label={settings.onTranslate(LANGUAGE_LABELRECYCLEBIN)}
      checked={checked}
      onChange={select}
    />
  )
})